import axios from 'axios'
import router from '../router/index'
import store from '../store/'
import VueCookies from 'vue-cookies'

const ClientPortal = axios.create( {
    withCredentials: true,
    validateStatus: null
} )

ClientPortal.interceptors.request.use((config) => {
    store.commit('loading/setLoading', true)
    try {
        if (!['get', 'head', 'options'].includes(config.method)) {
            config.headers['X-CSRF-TOKEN'] = VueCookies.get('x_csrf_token')
        }
    } catch (error) {
        console.error(error)
    }
    
    return config
})

// ClientPortal.interceptors.request.use((request) => {
//   const now = moment();
//   if(parseInt(process.env.VUE_APP_MAINTENANCE_START) <= now.hour() && now.hour() <= parseInt(process.env.VUE_APP_MAINTENANCE_END)) {
//     router.push("/serverMaintenance");
//   }
//   return request;
// });

ClientPortal.interceptors.response.use((response) => {
    store.commit('loading/setLoading', false)
    if (response.status < 500) {
        if (response.status === 423) {
            store.commit('IS_ACCOUNT_LOCKED', true)
        }

        if (response.status == 401) store.commit('IS_SESSION_EXPIRED', true)

        return response
    } else {
        router.push('/serverError')
        return
    }
}, (error) => {
    store.commit('loading/setLoading', false)

    if (error.code === 'ERR_CANCELED') return 

    // No response object at all => connection refused / DNS failure / offline
    if (!error.response || error.message && error.message.includes('ERR_CONNECTION_REFUSED')) {
        router.push('/clientOffline')
        return Promise.reject(error)
    }

    // Any other error that does have a response but still landed here
    console.log('Request failed with response: ', error.response)
    return Promise.reject(error)
})

export default ClientPortal
